import { authHeader, handleResponse, authHeaderFormData } from "../helpers";
export const ProductVenderMappingService = {
  fetchSecondaryPackingData,
  GetVendorListDDL,
  GetVendorProduct,
  ProductDDL,
  createScheme,
  GetSecondaryPackingReportExport,
  createMapping,
  UploadMapping,
};

function fetchSecondaryPackingData(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  
  return fetch(
    `${process.env.REACT_APP_API_URL}ProductVenderMapping/GetProductVenderDetailsReport`,
    requestOptions
  ).then(handleResponse);
}

function GetSecondaryPackingReportExport(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}ProductVenderMapping/GetProductVenderDetailsReport`,
    requestOptions
  ).then(handleResponse);
}

function ProductDDL() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}ProductMaster/GetProductDLL`,
    requestOptions
  ).then(handleResponse);
}

function createScheme(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}Gift/CreateGift`,
    requestOptions
  ).then(handleResponse);
}

function createMapping(formData) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(formData),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}ProductVenderMapping/ProductVendor`,
    requestOptions
  ).then(handleResponse);
}

function GetVendorListDDL(UserId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}ProductVenderMapping/GetVendorListDDL?UserId=${UserId}`,
    requestOptions
  ).then(handleResponse);
}

function GetVendorProduct(UserId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}ProductVenderMapping/GetVendorProduct?UserId=${UserId}`,
    requestOptions
  ).then(handleResponse);
}

function UploadMapping(formData) {
  const requestOptions = {
    method: "POST",
    headers: authHeaderFormData(),
    body: formData,
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}ProductVenderMapping/UploadMapping`,
    requestOptions
  ).then(handleResponse);
}
